// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu');
	const menuOpenTarget = document.querySelector('body');

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close');
			menuOpenTarget.classList.toggle('is-menu-open');
		} )
	}



	// Hamberger Menu Anchor
	// --------------------------------------------------------------- //

	const anchorLink = document.querySelectorAll('.has-anchor a');

	for ( let i = 0; i < anchorLink.length; i++) {

		anchorLink[i].addEventListener('click', function(event) {
			dropDownButton.classList.toggle('is-close');
			menuOpenTarget.classList.toggle('is-menu-open');
		});

	}




	// Pagetop
	// --------------------------------------------------------------- //

	const pagetop = document.getElementById('js-pagetop');
	pagetop.addEventListener('click', function() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});



	// Accordion
	// --------------------------------------------------------------- //

	const titles = document.querySelectorAll('.wp-pattern-accordion-contents__title a');

	titles.forEach(function(title) {
		const content = title.parentElement.nextElementSibling;
		const parent = title.closest('.wp-pattern-accordion-contents');

		if ( parent.classList.contains('is-open') ) {
			content.style.maxHeight = content.scrollHeight + 'px';
			parent.classList.add('is-open');
		} else {
			content.style.maxHeight = '0';
			parent.classList.remove('is-open');
		}

		title.addEventListener('click', function() {
			if (content.style.maxHeight === '0px' || content.style.maxHeight === '') {
				content.style.maxHeight = content.scrollHeight + 'px';
				parent.classList.add('is-open');
			} else {
				content.style.maxHeight = '0';
				parent.classList.remove('is-open');
			}

			//content.classList.toggle('is-open');
		});
	});



	// Floating
	// --------------------------------------------------------------- //

	const floatingBtn = document.getElementById('js-floating');
	const footer = document.querySelector('.site-footer');
	if (!floatingBtn || !footer) return;

	function toggleFloatingButton() {
		const scrollY = window.scrollY || window.pageYOffset;
		const winHeight = window.innerHeight;
		const footerRect = footer.getBoundingClientRect();
		const footerTop = footerRect.top + scrollY;

		// ボタンの下端（画面下端 - 余白）
		const btnBottomY = scrollY + winHeight - 0; // 00px余白、必要に応じて変更

		// フッターに重なったらis-active外す
		const isOverFooter = btnBottomY >= footerTop;

		if (scrollY >= 80 && !isOverFooter) {
			floatingBtn.classList.add('is-active');
		} else {
			floatingBtn.classList.remove('is-active');
		}
	}

	window.addEventListener('scroll', toggleFloatingButton);
	window.addEventListener('resize', toggleFloatingButton);
	toggleFloatingButton();


} );





